/* Abaza: Warenkorb-Drawer – „Noch schnell mitnehmen?“, Lieferdatum, Mengenrabatt-Hinweis. EcomVorsprung, Run „Drawer 2“.
   - Lädt die Vorschläge aus sections/abaza-xsell.liquid (?section_id=abaza-xsell) und zeigt sie im Drawer unter den Artikeln.
   - Rechnet das Lieferdatum aus (data-min / data-max Werktage, Mo–Fr) für [data-abz-eta].
   - Knopf „+n“ beim Mengenrabatt-Hinweis (snippets/abaza-staffel-hint.liquid) erhöht die Menge der Zeile.
   Aktualisiert sich bei jeder Warenkorb-Änderung (Theme-Events + Beobachtung von #AjaxCartForm).
   Eingebunden in snippets/cart-subtotal.liquid (oben). */
(function () {
  if (window.abzCart) return;
  window.abzCart = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var sidebar, box, timer, loading = false, again = false;

  function workdays(from, n) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }

  function fillEta() {
    var els = document.querySelectorAll('[data-abz-eta]:not([data-done])');
    if (!els.length) return;
    var now = new Date();
    for (var i = 0; i < els.length; i++) {
      var min = parseInt(els[i].getAttribute('data-min'), 10) || 2;
      var max = parseInt(els[i].getAttribute('data-max'), 10) || 4;
      var lang = els[i].getAttribute('data-lang') === 'bs' ? 'bs-BA' : 'de-DE';
      var opt = { weekday: 'short', day: '2-digit', month: '2-digit' };
      var t;
      try { t = workdays(now, min).toLocaleDateString(lang, opt) + ' – ' + workdays(now, max).toLocaleDateString(lang, opt); } catch (e) { t = null; }
      if (t) els[i].textContent = t;
      els[i].setAttribute('data-done', '');
    }
  }

  function place() {
    if (!sidebar || !box) return;
    var top = sidebar.querySelector('.sidebar__body-top');
    var form = top && top.querySelector('.cart-form');
    if (form && box.previousElementSibling !== form) form.insertAdjacentElement('afterend', box);
    else if (!box.parentNode) (top || sidebar).appendChild(box);
  }

  function load() {
    if (loading) { again = true; return; }
    loading = true;
    fetch(root + '?section_id=abaza-xsell', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var doc = new DOMParser().parseFromString(t, 'text/html');
        var data = doc.getElementById('abz-xsell-data');
        var n = data ? parseInt(data.getAttribute('data-count'), 10) || 0 : 0;
        box.innerHTML = n > 0 ? data.innerHTML : '';
        place();
      })
      .catch(function () {})
      .then(function () {
        loading = false;
        if (again) { again = false; load(); }
      });
  }

  function queue() {
    clearTimeout(timer);
    timer = setTimeout(function () { load(); fillEta(); }, 250);
  }

  function post(url, body, btn) {
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        var inDrawer = btn && btn.closest && btn.closest('#site-cart-sidebar');
        if (inDrawer && typeof window.refreshCart === 'function') window.refreshCart(true);
        else location.reload();
      })
      .catch(function (e) { if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); } return Promise.reject(e); });
  }

  function onClick(e) {
    var t = e.target.closest && e.target.closest('[data-abz-xs-add], [data-abz-tier-line]');
    if (!t) return;
    e.preventDefault();
    if (t.hasAttribute('data-abz-xs-add')) {
      var id = parseInt(t.getAttribute('data-abz-xs-add'), 10);
      if (id) post('cart/add.js', { items: [{ id: id, quantity: 1 }] }, t).then(function () {
        // Messung: Bestellung bekommt das Attribut „Zusatzkauf Drawer“
        return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Zusatzkauf Drawer': 'ja' } }) });
      }).catch(function () {});
    } else {
      var line = parseInt(t.getAttribute('data-abz-tier-line'), 10);
      var qty = parseInt(t.getAttribute('data-abz-tier-qty'), 10);
      if (line && qty) post('cart/change.js', { line: line, quantity: qty }, t).catch(function () {});
    }
  }

  function init() {
    sidebar = document.getElementById('site-cart-sidebar');
    fillEta();
    // Warenkorb-Seite: Mengenrabatt-Knopf ausserhalb des Drawers
    document.addEventListener('click', function (e) {
      if (sidebar && sidebar.contains(e.target)) return;
      if (e.target.closest && e.target.closest('[data-abz-tier-line]')) onClick(e);
    });
    if (!sidebar) return;
    box = document.createElement('div');
    box.className = 'abz-xs';
    place();
    sidebar.addEventListener('click', onClick);

    var form = document.getElementById('AjaxCartForm');
    if (form) new MutationObserver(queue).observe(form, { childList: true });
    var sub = document.getElementById('AjaxCartSubtotal');
    if (sub) new MutationObserver(fillEta).observe(sub, { childList: true, subtree: true });
    document.addEventListener('krown:cart:add', queue);
    document.addEventListener('krown:cart:update', queue);
    load();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
